import { Query } from '../Model/Query';
import '../Model/Bussiness';
import { RegisterInOut } from '../Model/RegisterInOut';
export class RecordsIntoOutService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findRegisters(opts) {
        var _a;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
                query.addFilter('search', [opts.filters.search]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`register_into?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los registros de entrada y salida.`);
            }
            const content = await response.json();
            return content.map(diligence => new RegisterInOut(diligence).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async saveRegisters(register) {
        const response = await this.apiService.post('register_into', register);
        if (!response.ok) {
            throw new Error(`Error al obtener los registros de entrada y salida.`);
        }
        return true;
    }
    async lastInRegister(year) {
        if (year) {
            const response = await this.apiService.get('register_into_in_register/' + year);
            if (!response.ok) {
                throw new Error(`Error al obtener el numero de registro.`);
            }
            const content = await response.text();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener el año.`);
        }
    }
    async lastOutRegister(year) {
        if (year) {
            const response = await this.apiService.get('register_into_out_register/' + year);
            if (!response.ok) {
                throw new Error(`Error al obtener el numero de registro.`);
            }
            const content = await response.text();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener el año.`);
        }
    }
    async getRecordsByThird(third_id) {
        const response = await this.apiService.get('registers_into_out_register/' + third_id);
        if (!response.ok) {
            throw new Error(`Error al obtener los registros de entrada y salida.`);
        }
        const content = await response.json();
        return content.map(diligence => new RegisterInOut(diligence).getState());
    }
    async getRecordsQuantity(opts) {
        var _a;
        const query = new Query();
        if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
            query.addFilter('search', [opts.filters.search]);
        }
        const params = this.queryParamsFactory.createQueryParams(query);
        const response = await this.apiService.get(`register_into_quantity?${params}`);
        if (!response.ok) {
            throw new Error(`Error al obtener los registros de entrada y salida.`);
        }
        const content = await response.json();
        return parseInt(content);
    }
}
